export const normaliseChatMessage = (message) => ({
    ...message,
    IsPrivileged: message.IsPrivileged ?? false,
    VisibleToTarget: message.VisibleToTarget ?? true,
});
export const normaliseChatMessages = (messages) => messages.map(normaliseChatMessage);
export const getDefaultIsOwnMessage = (currentUserID, actorContextID, authorUserID, authorContextID) => (currentUserID != null && authorUserID === currentUserID) ||
    (actorContextID != null && authorContextID === actorContextID);
export const getDefaultMessageSide = (input) => {
    if (input.isPrivilegedView) {
        return input.isPrivilegedMessage ? 'right' : 'left';
    }
    if (input.isPrivilegedMessage) {
        return 'left';
    }
    return input.isOwnMessage ? 'right' : 'left';
};
export const getDefaultMessageBubbleClassName = (input) => input.messageSide === 'right'
    ? [
        'min-w-0 rounded-xl px-4 py-3 text-base leading-snug',
        'text-[oklch(1_0_0)]',
        'bg-[oklch(var(--chat-l-accent-bubble)_var(--chat-c-accent)_var(--chat-hue))]',
    ]
    : [
        'min-w-0 rounded-lg border px-4 py-3 text-base leading-snug',
        'text-[oklch(var(--chat-l-text)_0_0)]',
        'bg-[oklch(var(--chat-l-surface-bubble)_0_0)]',
        'border-[oklch(var(--chat-l-text)_0_0_/_0.2)]',
    ];
export const getThreadDisplayTitle = (thread, fallback = 'Thread') => {
    const threadTitle = thread?.Title?.trim() ?? '';
    if (threadTitle !== '') {
        return threadTitle;
    }
    return thread != null ? `Thread #${thread.ID}` : fallback;
};
//# sourceMappingURL=message-utils.js.map